import React, { useEffect, useState } from "react";
import { getNews } from "../Service/Api";
import LazyLoad from "react-lazyload";
import { Link, useNavigate } from "react-router-dom";
import RightNavigationArrow from "../utlis/RightNavigationArrow";
const arrowImage =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAItJREFUeAGNz70NgzAQBeD3nBTXRPIILlkjGyQdZTwZbbqMkDUoGYHSEj+HQQJZ/Aiuejp99t3xkeUfgAVOyuBi0bqXDSI2bd4BR5ofVJc+1y9tlrsO/MfoQNYzNocIqFT7dzJlHzXQp8TQpcfsoVB+q3SauYImGL8uztC04w3wbcQt1G9QkBoS/BgHNqo+V7vQUDAAAAAASUVORK5CYII=";
const DUMMY_DATA = [
  {
    image: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/news.jpg",
    ],
    title: "News",
    description: "News Description",
    fromDate: "DD-MM-YYYY",
  },
  {
    image: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/news.jpg",
    ],
    title: "News",
    description: "News Description",
    fromDate: "DD-MM-YYYY",
  },
  {
    image: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/news.jpg",
    ],
    title: "News",
    description: "News Description",
    fromDate: "DD-MM-YYYY",
  },
  {
    image: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/news.jpg",
    ],
    title: "News",
    description: "News Description",
    fromDate: "DD-MM-YYYY",
  },
  {
    image: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/news.jpg",
    ],
    title: "News",
    description: "News Description",
    fromDate: "DD-MM-YYYY",
  },
  {
    image: [
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/news.jpg",
    ],
    title: "News",
    description: "News Description",
    fromDate: "DD-MM-YYYY",
  },
];
const Activities = () => {
  const [data, setData] = useState([]); // State for gallery data
  const [loading, setLoading] = useState(true); // State for loading indicator

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const newsData1 = await getNews();

        const sortedData = newsData1.sort((a, b) => {
          const dataA = new Date(a.fromDate);
          const dataB = new Date(b.fromDate);
          return dataB - dataA;
        });
        console.log(sortedData);
        setData(sortedData);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
        // Handle error (e.g., show error message)
      } finally {
        setLoading(false); // Set loading to false after data fetching is complete
      }
    };
    fetchData();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };
  const navigate = useNavigate();

  function handleLinkClick() {
    navigate("/news");
  }
  return (
    <>
      <div
        className="recentactivites activities_home recentactivitesnew"
        onClick={() => {
          handleLinkClick();
        }}
      >
        <marquee
          onMouseOver={(event) => event.currentTarget.stop()}
          direction="up"
          onMouseOut={(event) => event.currentTarget.start()}
        >
          {data.length > 0 ? (
            data.map((item, index) => (
              <div class="recentactivitesbox" key={index}>
                <div className="col-lg-3">
                  <div class="recentactivitesimg">
                    <LazyLoad>
                      {item?.image.length > 0 ? (
                        <img
                          src={`https://webapi.entab.info/api/image/${item?.image[0]}`}
                          alt="Gallery"
                          className="img-fluid"
                        />
                      ) : (
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/news.jpg"
                          alt="Gallery Placeholder"
                          className="img-fluid"
                        />
                      )}
                    </LazyLoad>
                  </div>
                </div>
                <div
                  className="col-lg-9"
                  style={{ backgroundColor: "#F4EFD5" }}
                >
                  <div class="recentactivitedesc">
                    <div className="title_description">
                      <h6>
                        <span>
                          {item.title.split(" ").slice(0, 4).join(" ")}
                        </span>
                      </h6>
                      <p>{item.description}</p>
                      <p>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/cal.png"
                          className="img-fluid"
                        />
                        {formatDate(item.fromDate)}
                      </p>
                    </div>
                    {item.attachments && item.attachments.length > 0 && (
                      <Link
                        to={`https://webapi.entab.info/api/image/${item?.attachments[0]}`}
                        target="_blank"
                      >
                        <div className="view_attachments">
                          <span> view attachments</span>
                          <i class="bi bi-paperclip"></i>
                        </div>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <>
              {DUMMY_DATA.map((item, index) => (
                <div className="recentactivitesbox" key={index}>
                  <div className="recentactivitesimg">
                    <LazyLoad>
                      {item?.image.length > 0 ? (
                        <img
                          src={`${item?.image[0]}`}
                          alt="Gallery"
                          className="img-fluid"
                        />
                      ) : (
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/news.jpg"
                          alt="Gallery Placeholder"
                          className="img-fluid"
                        />
                      )}
                    </LazyLoad>
                  </div>
                  <div className="recentactivitedesc">
                    <div className="title_description">
                      <h6>
                        <span>
                          {item.title.split(" ").slice(0, 4).join(" ")}
                        </span>
                      </h6>
                      <p>{item.description}</p>
                      <p>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/cal.png"
                          className="img-fluid"
                        />
                        {item.fromDate}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
        </marquee>
      </div>
    </>
  );
};

export default Activities;
